/**
 * SMS Server : 短信配置
 *

 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/smsg/v1/{organizationId}',
  items: [
    /**
     *  发送一条短信消息，指定模板和参数
     */
    { key: 'sendSMS', url: '/messages/call/template', method: 'POST' },
    // 列表
    { key: 'getSMS', url: '/sms/servers', method: 'GET' },
    // 创建短信服务
    { key: 'addSMS', url: '/sms/servers', method: 'POST' },
    // 删除短信配置
    { key: 'deleteSMS', url: '/sms/servers', method: 'DELETE' },
    /**
     * 修改短信服务
     */
    { key: 'updateSMS', url: '/sms/servers', method: 'PUT' },
    /**
     * 查询短信服务配置
     */
    { key: 'detailSMS', url: '/sms/servers/{serverId}', method: 'GET' },
  ],
};

export default {
  ...generate(config),
};
